//libs/utils/gisApiKeys.js
import esriConfig from "@arcgis/core/config";
import { AppResource } from '@config/config';
// 1. Global Esri Platform key — covers basemaps, search, routing etc.
//esriConfig.apiKey = AppResource.VITE_ARCGIS_ESRI_KEY;

// 2. Scoped key for your private NIOGEMS service only
esriConfig.apiKeys.scopes = [
  {
    token: AppResource.VITE_NIOGEMS_GIS_APIKEY,
    urls: [AppResource.VITE_NIOGEMS_GIS_URL]  // ✅ correctly wrapped in an array
  }
  
];
